(function () {
  'use strict';

  // ── Chef carousel ────────────────────────────────────────────────────────
  function initChefCarousel(sectionEl) {
    var track = sectionEl.querySelector('.ws-chefs__track');
    var prev  = sectionEl.querySelector('.ws-chefs__nav--prev');
    var next  = sectionEl.querySelector('.ws-chefs__nav--next');
    if (!track || !prev || !next) return;

    function cardStep() {
      var card = track.querySelector('.ws-chef');
      var gap  = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 18) || 18;
      return card ? card.offsetWidth + gap : 240;
    }

    function updateNav() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft >= (track.scrollWidth - track.clientWidth - 4);
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -cardStep() * 2, behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  cardStep() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', updateNav, { passive: true });
    window.addEventListener('resize', updateNav);
    updateNav();
  }

  document.querySelectorAll('.ws-social-proof').forEach(initChefCarousel);

  // Re-init if section injected dynamically (theme editor)
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ws-social-proof')) {
      initChefCarousel(e.target);
    }
  });

  // ── Sticky bar ───────────────────────────────────────────────────────────
  function initStickyBar(sectionEl) {
    var bar = sectionEl.querySelector('.ws-sticky-bar');
    if (!bar) return;

    // Watch the main-product buy buttons and the final CTA section
    var heroBuy  = document.querySelector('.shopify-section--main-product') ||
                   document.querySelector('[id*="main"]') ||
                   document.querySelector('product-form');
    var finalCta = document.querySelector('.ws-final-cta');

    if (!heroBuy || !('IntersectionObserver' in window)) {
      // Fallback: always show after 300px scroll
      window.addEventListener('scroll', function () {
        bar.classList.toggle('ws-sticky-bar--show', window.scrollY > 300);
      }, { passive: true });
      return;
    }

    var heroVisible  = true;
    var finalVisible = false;

    function update() {
      bar.classList.toggle('ws-sticky-bar--show', !heroVisible && !finalVisible);
    }

    new IntersectionObserver(function (entries) {
      heroVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(heroBuy);

    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(finalCta);
    }
  }

  document.querySelectorAll('.ws-sticky-buy').forEach(initStickyBar);

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector('.ws-sticky-buy')) {
      initStickyBar(e.target);
    }
  });

})();
